
export class TournamentInfoLineVO {
    public rank: string;
    public gold: number = NaN;
    public chips: number = NaN;

    public toString(): string {
        return "rank: " + this.rank + ", gold: " + this.gold + ", chips: " + this.chips;
    }
}
